export const NAME = 'taskFeedback';
export const FINISH_ID_GET_INFO = 2;

export default { NAME, FINISH_ID_GET_INFO };

export const ALREADY_RESOLVED = 'Access restricted because its data';
export const HAS_NO_ACCESS_ERR_MSG = 'has no access to task';
